var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckhaken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Checkhaken__Icn/40px/Checkhaken",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Checkhaken__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Checkhaken__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Checkhaken__Path-Copy",
    transform: "rotate(40 20.517 17.487)",
    d: "M22.0131238 9.0616811 24.0093156 8.9383189 25.0658818 26.0352006 15.9674886 25.7392423 16.0325114 23.7402996 22.933 23.964z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckhaken);
export default __webpack_public_path__ + "static/media/Checkhaken.3a36d8e611f5a887ffdb2980c0db75da.svg";
export { ForwardRef as ReactComponent };